import { useMemo } from 'react'
import { useInbox } from '@/hooks/use-inbox'
import { InboxFoldersModePanel } from '@/components/features/inbox/InboxFoldersModePanel'
import { mapInboxItemToThread } from '@/components/features/inbox/mappers'
import { testIds } from '@/lib/test-ids'

/** Sidebar mode panel: folder nouns only; main index holds the thread list. */
export function InboxSidebarView({ dense = false }: { dense?: boolean }) {
  const { allItems } = useInbox()

  const allThreads = useMemo(() => allItems.map(mapInboxItemToThread), [allItems])

  return (
    <div className="flex flex-col flex-1 min-h-0 min-w-0 overflow-hidden" data-testid={testIds.inbox.sidebarPanel}>
      <InboxFoldersModePanel threads={allThreads} dense={dense} />
    </div>
  )
}
